import { useEffect, useState, useMemo } from 'react';
import Select, { components } from 'react-select';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';

  const Option = (props) => {
    const icon = props?.data?.icon;
    const label = props?.data?.label;
    const subLabel = props?.data?.subLabel;

    return (
      <components.Option {...props}>
        <div className='search-bar-custom-options-container'>
          {icon}
          <div className='search-bar-col'>
            {label}
            {subLabel && <div className='search-bar-sub-label-wrapper'>{subLabel}</div>}
          </div>
        </div>
      </components.Option>
    );
  };

  const SearchBarDropdown = ({
    options = [],
    defaultSelected = null,
    checkbox = false,
    placeholder = '',
    selectId = '',
    onChange = () => {},
  }) => {
  
  const [selectedOption, setSelectedOption] = useState(defaultSelected || null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    if (defaultSelected) {      
      setSelectedOption(defaultSelected);
    }
  }, [defaultSelected]);  

  const getChecked = (option) => {
    return selectedOption?.label === option?.label;
  };

  const handleChange = (option) => {
    setSelectedOption(option);
    onChange(option?.value);
  };

  const parsedOptions = useMemo(() => {

    if (!checkbox) return options;

    if (!isMounted) { 
      return options.map((opt) => ({
          ...opt,
          icon: null, // Or a div without the Checkbox
      }));      
    }

    return options.map((opt) => ({
      ...opt,
      icon: (
        <div className='search-bar-checkbox-wrapper'>
          <Checkbox
            checked={getChecked(opt)}
            onChange={() => onChange(opt.value)}
            disableRipple
          />
        </div>
      ),
    }));
  }, [options, checkbox, selectedOption, onChange, isMounted]);

  return (
      <>
          { isMounted ? (
            <div className='search-bar-select-wrapper' id={`${selectId}-select`}>
              <Select
                value={selectedOption}
                onChange={handleChange}
                options={parsedOptions}
                placeholder={placeholder}
                components={{ Option }}
                aria-label={selectId}
                inputId={selectId}
                styles={{
                  valueContainer: (base) => ({ ...base, padding: 0 }),
                  control: (base) => ({
                    ...base,
                    border: 'none',
                    boxShadow: 'none',
                    background: 'transparent',
                  }),
                  placeholder: (defaultStyles) => ({
                    ...defaultStyles,
                    color: '#fff',
                    fontSize: 16,
                  }),
                  option: (provided) => ({
                    ...provided,
                    color: '#000',
                    fontSize: 16,
                  }),
                }}
                theme={(selectTheme) => ({
                  ...selectTheme,
                  borderRadius: 0,
                  backgroundColor: '#000',
                  colors: {
                    ...selectTheme.colors,
                    primary25: '#F1F1F1',
                    primary: '#A2A2A2',
                    primary50: '#F1F1F1',
                  },
                })}
              />
            </div>
          )
          : (
            <div className='search-bar-select-wrapper' id={`select-loading`}>                
                <div style={{ height: '38px', width: '200px', backgroundColor: '#f0f0f0' }}>Loading Selector...</div>
            </div>
          )
        }
      </>
      




  );
};

SearchBarDropdown.propTypes = {
  options: PropTypes.array,
  defaultSelected: PropTypes.object,
  checkbox: PropTypes.bool,
  placeholder: PropTypes.string,
  selectId: PropTypes.string,
  onChange: PropTypes.func,
};

export default SearchBarDropdown;

